import { isFlightDemoEnabled } from 'config';

const FLIGHT_DEMO_ROOT = '/flight-demo';
const APP_BASENAME = '/book';

// Mirrors getBaseName() in router.tsx: the app is served under /book via the
// vercel rewrites, and from / when running locally.
export const getFlightDemoBasename = (pathname: string): string =>
  pathname.startsWith(APP_BASENAME) ? APP_BASENAME : '/';

// Routes are single path segments (/flight-demo, /flight-demo-extras, ...) on
// purpose: the build uses relative asset URLs (homepage "."), so a nested
// path such as /book/flight-demo/extras would load its JS from the wrong URL on
// a hard refresh.
export const isFlightDemoPath = (pathname: string): boolean => {
  const basename = getFlightDemoBasename(pathname);
  const relative =
    basename === '/' ? pathname : pathname.slice(basename.length);

  return (
    relative === FLIGHT_DEMO_ROOT || relative.startsWith(`${FLIGHT_DEMO_ROOT}-`)
  );
};

// Single decision used by index.tsx: the demo is mounted only on a demo path
// AND when the build allows it (see isFlightDemoEnabled in config.ts).
export const shouldShowFlightDemo = (pathname: string): boolean =>
  isFlightDemoEnabled() && isFlightDemoPath(pathname);
